module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tab top attached loading",
    attrs: {
      "id": "notes-list-container"
    }
  }, [_c('ul', _vm._l((_vm.notes), function(note, id) {
    return _c('note-card', {
      attrs: {
        "note": note,
        "id": id,
        "db": _vm.db_notes
      }
    })
  })), _c('div', {
    staticClass: "ui container",
    class: _vm.has_notes ? "" : "shown",
    attrs: {
      "id": "empty-list"
    }
  }, [_c('h1', [_vm._v("there's nothing here :o")])]), _c('div', {
    staticClass: "button-clear"
  }), (_vm.uservalid) ? _c('button', {
    staticClass: "circular ui icon button massive primary",
    on: {
      "click": _vm.show_add
    }
  }, [_c('i', {
    staticClass: "icon plus"
  })]) : _vm._e(), _c('add-note', {
    attrs: {
      "id": "add-note",
      "db": _vm.db_notes
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a06d34aa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotesList.vue
// module id = 57
// module chunks = 0